import React from 'react';
import { AlertCircle, CheckCircle, Clock, Eye, XCircle } from 'lucide-react';

/** @param {{status:string, priority?:'high'|'medium'|'low'}} props */
export default function StatusBadge({ status, priority }) {
  const getStatusConfig = (s) => {
    switch (s) {
      case 'draft':     return { color: 'bg-gray-100 text-gray-700 border-gray-200',   Icon: AlertCircle, label: 'Draft' };
      case 'submitted': return { color: 'bg-blue-100 text-blue-700 border-blue-200',   Icon: Clock,       label: 'Submitted' };
      case 'approved':  return { color: 'bg-green-100 text-green-700 border-green-200',Icon: CheckCircle, label: 'Approved' };
      case 'rejected':  return { color: 'bg-red-100 text-red-700 border-red-200',      Icon: XCircle,     label: 'Rejected' };
      case 'in_review': return { color: 'bg-yellow-100 text-yellow-700 border-yellow-200', Icon: Eye,     label: 'In Review' };
      default:          return { color: 'bg-gray-100 text-gray-700 border-gray-200',   Icon: AlertCircle, label: 'Unknown' };
    }
  };
  const getPriorityColor = (p) => {
    switch (p) {
      case 'high': return 'border-l-red-500';
      case 'medium': return 'border-l-yellow-500';
      case 'low': return 'border-l-green-500';
      default: return 'border-l-gray-300';
    }
  };

  const { color, Icon, label } = getStatusConfig(status);

  return (
    <div className="flex items-center space-x-2">
      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${color}`}>
        <Icon className="w-3 h-3 mr-1" />
        {label}
      </span>
      {priority && <div className={`w-1 h-6 rounded-full ${getPriorityColor(priority)}`} title={`${priority} priority`} />}
    </div>
  );
}
